//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import OPZDialog from '@/components/OPZDialog';
import OPZTable from '@/components/OPZTable';
import api from '@/api/WMS/return/returnAPI';
export default {
  components: {
    OPZDialog: OPZDialog,
    OPZTable: OPZTable
  },
  props: {
    rowData: {
      type: [Object, null],
      default: null
    },
    fieldData: {
      type: [Object, null],
      default: null
    }
  },
  data: function data() {
    return {
      dialog: {
        title: '包裹单明细',
        width: 1000,
        visible: false,
        columns: [{
          prop: 'parcelNo',
          label: '包裹单号'
        }, {
          prop: 'sku',
          label: 'SKU'
        }, {
          prop: 'pictureUrl',
          label: '图片',
          type: 'image'
        }, {
          prop: 'batchNo',
          label: '批次'
        }, {
          prop: 'quantity',
          label: '商品数量'
        }, {
          prop: 'cancelQuantity',
          label: '取消发货数量'
        }, {
          prop: 'deliverQuantity',
          label: '实发数'
        }, {
          prop: 'saleLink',
          label: '销售链接'
        }, {
          prop: 'spu',
          label: 'spu'
        }, {
          prop: 'color',
          label: '颜色/尺码',
          type: 'html',
          htmlFormatter: function htmlFormatter(val, _ref) {
            var size = _ref.size;
            return "".concat(val || '--', "/").concat(size || '--');
          }
        }, {
          prop: 'specifications',
          label: '规格'
        }, {
          prop: 'stockAttri',
          label: '库存属性',
          formatter: function formatter(val) {
            if (val === 1) return '正品';
            if (val === 2) return '次品';
          }
        }, {
          prop: 'sourceParcelNo',
          label: '来源包裹单号'
        }],
        params: {
          parcelNo: this.rowData.despatchParcelNo
        }
      }
    };
  },
  methods: {
    getGetReturnDetailOrPackDetail: api.getReturnDetailOrPackDetail
  }
};